(function FormatDateDirective($, Adzuki)
{
    const FormatDate = {
        mounted(el, binding) {
            updateContent(el, binding.value);
        },
        updated(el, binding) {
            updateContent(el, binding.value);
        }
    };

    function parseDate(dateString) {
        // YYYY-MM-DD (date-only) — force UTC midnight to avoid timezone day-shift
        if ((/^\d{4}-\d{2}-\d{2}$/).test(dateString)) {
            return new Date(dateString + 'T00:00:00Z');
        }

        // M/D/YYYY or MM/DD/YYYY with optional time (e.g. "08/20/2026 4:00pm")
        // Use only the date portion so time/timezone cannot shift the calendar day
        const mdyMatch = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
        if (mdyMatch) {
            const month = Number(mdyMatch[1]);
            const day   = Number(mdyMatch[2]);
            const year  = Number(mdyMatch[3]);

            return new Date(Date.UTC(year, month - 1, day));
        }

        // Normalize "4:00pm" → "4:00 PM" for native Date parsing
        const normalized = dateString
            .replace(/(\d)\s*(am|pm)\b/i, '$1 $2')
            .replace(/\b(am|pm)\b/gi, (match) => match.toUpperCase());

        return new Date(normalized);
    }

    function updateContent(el, value) {
        // Handle both string and object formats
        const date    = typeof value === 'string' ? value : value?.date;
        const locale  = typeof value === 'string' ? 'en-US' : (value?.locale || 'en-US');
        const options = typeof value === 'string' ? {} : (value?.options || {});

        const defaultOptions = {
            year : 'numeric',
            month: 'long',
            day  : 'numeric'
        };

        if (!date) {
            el.textContent = '';
            return;
        }

        try {
            const parsedDate = parseDate(String(date));

            if (isNaN(parsedDate.getTime())) {
                console.error('Error formatting date: invalid date value', date);
                el.textContent = '';
                return;
            }

            el.textContent = new Intl.DateTimeFormat(
                locale,
                {
                    ...defaultOptions,
                    ...options,
                    timeZone: 'UTC'
                }
            ).format(parsedDate);
        } catch (error) {
            console.error('Error formatting date:', error);
            el.textContent = '';
        }
    }

    Adzuki.VueDirectives.FormatDate = FormatDate;
}(jQuery, window.Adzuki || {}));
